module.exports = __webpack_public_path__ + "media/images/map-screenshot-5b41f9f6c9ff6425b442ce5dc71272ba.png";